var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleAddFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#000",
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M17.585 11.45a.55.55 0 1 1 0 1.1H12.55v5.034a.55.55 0 1 1-1.1 0V12.55H6.415a.55.55 0 1 1 0-1.1h5.035V6.415a.55.55 0 1 1 1.1 0v5.035z",
  clipRule: "evenodd"
})));
export { SvgCircleAddFilled as ReactComponent };